import { InjectionToken } from '@angular/core';
import { MetaReducer } from '@ngrx/store';

import { environment } from '../../../environments/environment';
import * as fromUI from './ui.reducer';
import * as fromAuth from './auth.reducer';
import * as fromSession from './session.reducer';
import * as fromExpertise from './expertise.reducer';
import * as fromContact from './contact.reducer';
import * as fromInvoice from './invoice.reducer';


export const REDUCER_TOKEN = new InjectionToken<any>('Registered Reducers');

/**
 * Define here your app state
 *
 * [IMPORTANT]
 * There are some **reserved** slice of the state
 * that you **can not** use in your application ==> app |user | notification
 */
/* tslint:disable-next-line */
export interface AppState {
    ui: fromUI.UIState;
    auth: fromAuth.AuthState;
    session: fromSession.SessionState;
    expertise:  fromExpertise.ExpertiseState;
    contact: fromContact.ContactState;
    invoice: fromInvoice.InvoiceState;
}

/**
 * Define here the reduceres of your app
 */
const rootReducer = Object.assign({}, {
    ui: fromUI.uiReducer,
    auth: fromAuth.authReducer,
    session: fromSession.sessionReducer,
    expertise: fromExpertise.expertiseReducer,
    contact: fromContact.contactReducer,
    invoice: fromInvoice.invoiceReducer,
});

export function getReducers() {
    return rootReducer;
} 


